import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaMinusSquare } from "react-icons/fa";
import AppSettings from "../../configs/appSettings";
import {useInventories} from "../../services/useProductDetail";

const Index = ({ inventories, sku }: { inventories: any, sku: string }) => {
  var totalOnHand = 0;
  return (
    <div>
      {inventories && inventories.map((storeWarehouse:any, index:number) => {
        totalOnHand += storeWarehouse.availableOnHand;

      })}
      <div className="row">
        <p>
        <span className="text-info">Estimated Available Inventory</span> - See Expedite Report For Increased Accuracy
        </p>
      </div>
      <div className="row">
        <div className="col-6 pr-0">
          <p className="pl-3 mb-0 border-bottom"><FaMinusSquare /> TOTAL</p>
        </div>
        <div className="col-6 text-right pl-0 mb-0">
          <p id="total" className="text-success pr-3 border-bottom">{totalOnHand}</p>
        </div>
      </div>
      {inventories && inventories.map((storeWarehouse:any, index:number) => {
              var onHand = storeWarehouse.availableOnHand;
              return <div key={"inv" + index} className="row">
                <div className="col-6">
                  <p className="pl-3 ml-3">{storeWarehouse.warehouse}</p>
                </div>
                <div className="col-6 text-right">
                    <p id="fg" className="text-success pr-3">{onHand}</p>
                </div>
            </div>;
            })}
    </div>
  );
};

export default Index;
